import { useEffect, useState } from "react";

export const useIsRtl = () => {
  const [isRtl, setIsRtl] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (typeof document != undefined) {
      const documentIsRtl = document?.dir === "rtl";
      if (documentIsRtl !== isRtl) {
        setIsRtl(document?.dir === "rtl");
      }
    }
  });

  return isRtl;
};
